import { render, staticRenderFns } from "./NoResultsImage.vue?vue&type=template&id=2648e7d8&"
import script from "./NoResultsImage.vue?vue&type=script&lang=ts&"
export * from "./NoResultsImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports